import { render, staticRenderFns } from "./EcoHubTechUserForm.vue?vue&type=template&id=9b1ee9c8"
import script from "./EcoHubTechUserForm.vue?vue&type=script&lang=js"
export * from "./EcoHubTechUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports